import React, {Component} from "react";
import {connect} from "react-redux";
import PanelGroupController from "../../components/PanelGroupController";
import {cx} from "../../lib/ClassSet";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import update from "immutability-helper";
import {dateWithTimeFormat} from "../../lib/DateFormatter";
import "./LogPanel.scss";

class DeliveryLogPanel extends Component {

  componentDidMount() {
    if (this.props.deliveryId) {
      this.subscribe(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.deliveryId && (prevProps.deliveryId !== this.props.deliveryId)) {
      this.subscribe(this.props);
    }
  }

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(props, {});
  }  


  render() {
    let {loading, error, subscriptionLog} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let items = fromJS(subscriptionLog);

    let elements = items.map(x => {
      return <LogItem key={x.get("eventId")} data={x} />
    })

    return (
      <div className="LogPanel">
        <PanelGroupController title="Event Log" expanded={true}>
          {elements}
        </PanelGroupController>
      </div>
    )
  }

}


const LOG = gql`
  query subscriptionLog($filter:SubscriptionLogFilterInput!) {
    subscriptionLog(filter: $filter) {
      subscriptionId
      deliveryId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt
    }
  }
`

const LOG_SUBSCRIPTION = gql`
  subscription onLogUpdated($deliveryId:ID!) {
    updatedSubscriptionDeliveryLog(deliveryId: $deliveryId) {
      subscriptionId
      deliveryId
      eventId
      eventType
      description
      isError
      transient
      errorCode
      occuredAt      
    }
  }
`


const withQuery = graphql(LOG, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: {
        deliveryId: props.deliveryId
      }
    }
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: LOG_SUBSCRIPTION,
      variables: {
        deliveryId: props.deliveryId
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          subscriptionLog: {
            $unshift: [subscriptionData.data.updatedSubscriptionDeliveryLog]
          }
        })
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

export default withQuery(withSubscription(DeliveryLogPanel));



const LogItem = (props) => {

  let data = props.data;
  let code = data.get("isError") ? "Err" : "Ok";

  let classes = cx({
    "item": true,
    "u-error": data.get("isError")
  })

  var rxp = /\[([a-z_]+):([0-9a-z \-_:]+)\]/gi;
  let markup = {__html: data.get("description").replace(rxp, '<span>$2</span>')};

  return (
    <div className={classes}>
      <div className="header">
        <div className="result">{code}</div>
        <div>
          <div className="description" dangerouslySetInnerHTML={markup}/>
          <span className="occuredAt">{dateWithTimeFormat(data.get("occuredAt"))}</span>
        </div>
      </div>
    </div>
  )

}